import { createFileRoute } from '@tanstack/react-router'
import { ReceiptsPage } from '@/components/receipts/ReceiptsPage'

// F-FE-N192: the receipts inbox, behind FEATURE_RECEIPT_SCAN.
export const Route = createFileRoute('/admin/receipts')({
  component: ReceiptsPage,
})
